import ky, { HTTPError } from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';
import { ZoneSchema } from '../get-detection-zone/getDetectionZonePromise';

const EDIT_PRESENCE_ZONE_SCHEMA = z.object({
  message: z.enum(['zones created']),
});
export type EditPresenceZoneSchema = z.infer<typeof EDIT_PRESENCE_ZONE_SCHEMA>;

interface ApiPresenceZoneObj {
  name: string;
  min_time: number;
  poly: Array<Array<number>>;
  epos_filters: ZoneSchema['epos_filters'];
  category: string;
}

export interface EditPresenceZonePromiseParam {
  display_id: string;
  zones: Array<ApiPresenceZoneObj>;
}

export const editPresenceZonePromise = async (param: EditPresenceZonePromiseParam) => {
  try {
    const headers = getHeadersWithBearerToken();

    const formData = new FormData();
    formData.append('payload', JSON.stringify(param));

    const response = await ky
      .post(`${ENV.API_URL}/api/edit_presence_zone/`, {
        headers,
        body: formData,
      })
      .json();

    const result = EDIT_PRESENCE_ZONE_SCHEMA.safeParse(response);

    if (!result.success) {
      throw new Error('Invalid response');
    }

    return {
      success: true,
      message: 'Presence zone edited successfully',
    };
  } catch (error) {
    if (error instanceof HTTPError) {
      const errorRes = (error.data as { message: string })?.message;

      console.error(`Error editing presence zone: ${errorRes}`);

      return {
        success: false,
        message: errorRes,
      };
    }

    const errorMessage = (error as Error)?.message || 'Unknown error';

    console.error('Error editing presence zone:', errorMessage);

    return {
      success: false,
      message: errorMessage,
    };
  }
};
